import WorkTimeUsersTable from "./WorkTimeUsersTable";
import { groupRowsByUser } from "../utils/helpers";

export default function WorkTimeUsersTables({
  rows,
  loading,
  onChangeRow,
  onDeleteRow,
  onApproveRows,
  onExportRows,
  onSaveNote,
  onApproveNote,
  onDeleteNote,
  canEdit,
}) {
  const groups = groupRowsByUser(rows);

  if (!loading && groups.length === 0) {
    return <div>Brak danych</div>;
  }

  return (
    <div className="d-flex flex-column gap-4">
      {groups.map((group) => (
        <WorkTimeUsersTable
          key={group.userId}
          group={group}
          onChangeRow={onChangeRow}
          onDeleteRow={onDeleteRow}
          onApproveRows={onApproveRows}
          onExportRows={onExportRows}
          onSaveNote={onSaveNote}
          onApproveNote={onApproveNote}
          onDeleteNote={onDeleteNote}
          canEdit={canEdit}
        />
      ))}
    </div>
  );
}
